import moment from "moment";

export const durationSelection = async (listingApi, orderDateFrom, setorderDateFrom, setorderDateTo, status, searchShow, limit, offset, defaultSearch, setdateSelector, isSelect, dateSelector, isEcomCalen, setCurrentPage) => {
  if (isSelect) {
    console.log('orderDateFrom', orderDateFrom);
    setdateSelector(orderDateFrom);
    let formData = {
      limit,
      offset,
      searchBy: Object.keys(searchShow).length !== 0 ? searchShow.searchBy : defaultSearch,
      searchTxt: Object.keys(searchShow).length !== 0 ? searchShow.searchTxt : '',
      status,
      dateSelector: isEcomCalen ? orderDateFrom : dateSelector,
    };
    console.log(formData);
    isEcomCalen ? setCurrentPage(1) : '';
    listingApi(formData);
  } else {
    setorderDateFrom(orderDateFrom);
    let orderDateTo = moment().format('YYYY-MM-DD');
    setorderDateTo(orderDateTo);

    let formData = {
      limit,
      offset,
      searchBy: Object.keys(searchShow).length !== 0 ? searchShow.searchBy : defaultSearch,
      searchTxt: Object.keys(searchShow).length !== 0 ? searchShow.searchTxt : '',
      status,
      orderDateFrom,
      orderDateTo,
    };
    console.log(formData);
    listingApi(formData);
  }
};

export const onChangeMethod = async (listingApi, dateString, setorderDateFrom, setorderDateTo, status, searchShow, limit, offset, defaultSearch, setCurrentPage,isEcom) => {
  dateString[0] ? setorderDateFrom(dateString[0]) :setorderDateFrom('');
  dateString[1] ? setorderDateTo(dateString[1]) : setorderDateTo('');
  let formData = {
    limit: limit,
    offset:isEcom ? (dateString[0] ? offset : 0):offset,
    searchBy: Object.keys(searchShow).length !== 0 ? searchShow.searchBy : defaultSearch,
    searchTxt: Object.keys(searchShow).length !== 0 ? searchShow.searchTxt : '',
    status, //1 = In-Transit (Inprogress), 2 = Sent to Lab, 3 = Completed
    orderDateFrom: dateString[0], //2023-03-03  only give date without time
    orderDateTo: dateString[1],
  };
  isEcom && setCurrentPage && !dateString[0] ?setCurrentPage(1):""
  listingApi(formData);
};